export enum RenderingMutationTypes {
  SET_CAMERA_POS = 'SET_CAMERA_POS',
}
